import { SelectCombo } from 'components/Types/GeneralTypes';
import SelectItem2 from 'components/Varios/SelectNew';
import React, { useState } from 'react'

import { Card, CardTitle, CardBody, Input, Row, Col } from "reactstrap";

type PropsCardAnioEjecucion = {
    anio: number | undefined,
    listadoAnios:SelectCombo[],
    onChangeAnio:(anio:number) => Promise<void>
}


export default function CardAnioEjecucion(props: PropsCardAnioEjecucion) {

    const [anioSeleccionado, setanioSeleccionado] = useState<number|undefined>(props.anio)

    async function onChangeAnio(opcion:SelectCombo){
        const anioSeleccionado:number = +opcion.value;
        
        setanioSeleccionado(anioSeleccionado)
        await props.onChangeAnio(anioSeleccionado)
    }


    return (
        <Card className="cardParametrosHE">
            <CardTitle className="cardHeaderParametrosAnio"  >
                <span className='pl-3'>
                    Parámetros del sistema para el año
                </span>



            </CardTitle>

            <CardBody className="cardBodyParametrosHE">
                <Row>
                    <Col xl={12}>
                        <span className={"labelParametrosHE"}> Año de ejecución</span>

                    </Col>
                </Row>
                <Row className='row-container-bodyParamHE'  >

                    <Col xl={12} >

                        <Row>
                            <Col xl={12}>
                                {
                                    props.anio &&
                                    // <Input
                                    //     className="text-center"
                                    //     type={"number"}
                                    //     value={props.anio}
                                    //     readOnly
                                    // />
                                    <SelectItem2
                                        options={props.listadoAnios}
                                        placeholder=""
                                        name="regimenLaboral"
                                        id="regimenLaboral"
                                        icon="fa-caret-down"
                                        value={anioSeleccionado}
                                        onChange={(v,n,t,l) => onChangeAnio({value:v,label:l})}
                                        center = {true}

                                    />
                                }

                            </Col>
                        </Row>
                    </Col>
                </Row>

            </CardBody>



        </Card>
    )
}
